module.exports = __webpack_public_path__ + "linea-software-10.14427f95ed19faa7678d.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/linea/fonts/linea-software-10.svg
// module id = ../../../../../src/assets/linea/fonts/linea-software-10.svg
// module chunks = styles